import React, { useState } from 'react';

import { DropdownMenu } from '@/components/ui/dropdown-menu';
import { SidebarMenu, SidebarMenuItem } from '@/components/ui/sidebar';
import { WORKSPACES } from '../../../constants';
import DropdownMenuContent from './DropdownMenuContent';
import DropdownMenuTrigger from './DropdownMenuTrigger';

const WorkspaceSelect = () => {
  const [activeWorkspace, setActiveWorkspace] = useState(WORKSPACES[0]);

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger activeWorkspace={activeWorkspace} />
          <DropdownMenuContent setActiveWorkspace={setActiveWorkspace} />
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
};

export default WorkspaceSelect;
